<template>
  <div class="clause-wrapper">
    <div class="clause-body">
      <header class="header">保险条款</header>
      <div class="content">
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; line-height: 150%; font-size: 14pt">
          <span style="font-weight: bold">中国平安财产保险股份有限公司</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; line-height: 150%; font-size: 14pt">
          <span style="font-weight: bold">平安产险公路货物运输承运人责任保险条款</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 14pt">
          <span style="font-weight: bold">注册号：05CA2025000170292</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; line-height: 14pt">
          <span style="font-size: 10.5pt; font-weight: bold">总则</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第一条&nbsp;&nbsp;为减少、化解国内公路</span><span>货物</span><span>运输承运人的经营风险，可投保本保险。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二条&nbsp;&nbsp;</span><span>经道路运输管理机构许可并颁发《道路运输经营许可证》，在中华人民共和国境内</span
          ><span style="font-weight: bold">（不包括港、澳、台地区）</span><span>登记，合法从事</span><span>公路</span><span>货物运输的货运经营者，均可成为本保险的投保人、被保险人。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第三条 </span><span>被保险人按照本保险合同投保的运输车辆(以下简称运输车辆)是指取得道路运输管理机构配发的《道路运输证》，从事</span><span>公路</span
          ><span>货物运输的机动车辆。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第四条</span
          ><span
            >&nbsp;&nbsp;本保险合同由保险条款、投保单、保险单、保险凭证以及批单组成。凡涉及本保险合同的约定，均应采用书面形式。本保险合同由基本险、综合险二部分组成，其中综合险，投保人可选择投保</span
          ><span>，具体由投保人和保险人在投保时协商确定，以保险合同载明为准。</span><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">保险责任</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第五条</span
          ><span>&nbsp;&nbsp;在保险期间内，运输车辆在中华人民共和国境内运输和装卸保险单载明的货物时，因下列原因造成运输车辆上装载的货物毁损、灭失，依照中华人民共和国法律</span
          ><span style="font-weight: bold">（不包括港、澳、台地区法律</span><span>，以下简称</span><span>“</span><span>依法</span><span>”</span><span>）应由被保险人承担的经济赔偿责任</span
          ><span>，</span><span>保险人按照本保险合同的约定负责赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt"><span>（一）基本险</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt"><span>1.火灾、爆炸；</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>2.运输工具发生碰撞、倾覆。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（二）综合险（投保人可选择投保）</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>本保险除包括基本险责任外，保险人还负责赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>1.因受震动、碰撞、挤压而造成破碎、弯曲、凹瘪、折断、开裂或包装破裂致使货物散失；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>2.液体货物因受震动、碰撞或挤压致使所用容器（包括封口）损坏而渗漏，或用液体保藏的货物因液体渗漏而造成保藏货物腐烂变质；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>3.符合安全运输规定而遭受雨淋；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>4.在装货、卸货或转载时，因遭受不属于包装不善或装卸人员违反操作规程所造成的损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt"><span>&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">责任起讫</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">
            第六条&nbsp;&nbsp;保险责任自签发保险凭证和保险货物运离起运地发货人的最后一个仓库或储运处所时起，至该保险凭证上注明的目的地的收货人在当地的第一个仓库或储存处所时终止。但保险货物运抵目的地后，如果收货人未及时提货，则保险责任的终止期最多延长至以收货人接到《到货通知单》后的十五天为限（以邮戳日期为准）。
          </span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt"><span>&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">责任免除</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第七条 发生保险事故时存在下列情形的，保险人不负责赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（一）运输车辆无有效道路运输证或超范围经营；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（二）驾驶人员、押运人员、装卸管理人员不具备相应的从业资格； </span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（三）驾驶人员酒后、吸食或注射毒品、服用国家管制的精神药品或者麻醉药品并在药物发挥作用期间，驾驶运输车辆；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（四）运输货物为法律、行政法规禁止运输的货物。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第八条 由于下列原因造成被保险人承运货物的损失，保险人不负赔偿责任。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（一）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（二）行政行为或司法行为；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（三）地震、海啸、火山爆发及其他不可抗力；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（四）核事件或核爆炸；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（五）承运货物本身的缺陷或自然损耗、包装不善；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（六）投保人、被保险人或其雇员、代理人的故意行为或重大过失；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（七）盗窃和整件提货不着；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（八）其它不属于保险责任范围内的损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第九条 下列损失、费用和责任，保险人不负责赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（一）罚款、罚金及惩罚性赔偿；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（二）间接损失；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（三）精神损害赔偿；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（四）保险单载明的免赔额。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt"><span>&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt">
          <span style="font-weight: bold">赔偿限额与免赔额</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十条&nbsp;&nbsp;</span
          ><span style="font-weight: bold">本合同的赔偿限额包括每次事故赔偿限额、累计赔偿限额。各项赔偿限额由投保人与保险人协商确定，并在保险单中载明。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">本合同的每次事故免赔额由投保人与保险人在订立合同时协商确定，并于合同中载明。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">保险人义务</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十一条</span
          ><span>
            订立本保险合同时，采用保险人提供的格式条款的，保险人向投保人提供的投保单应当附格式条款，保险人应当向投保人说明本保险合同的内容。对本保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明；未作提示或者明确说明的，该条款不产生效力。</span
          >
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十二条 保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十三条 保险人依本保险条款第</span><span>十七</span><span>条取得的合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>保险人在保险合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担赔偿责任。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十四条</span
          ><span> 保险人按照本保险条款第二十二条的约定，认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人补充提供。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十五条 保险人收到被保险人的赔偿请求后，应当及时作出是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定，但合同另有约定的除外。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span
            >保险人应当将核定结果通知被保险人。对属于保险责任的，在与被保险人达成有关赔偿金额的协议后十日内，履行赔偿义务。本保险合同对赔偿期限有约定的，保险人应当按照约定履行赔偿义务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人发出拒绝赔偿保险金通知书，并说明理由。</span
          >
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>保险人未履行本条规定义务的，除支付保险金外，应当赔偿被保险人因此受到的损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十六条</span
          ><span>
            保险人自收到赔偿保险金的请求和有关证明、资料之日起三十日内，对其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最终确定赔偿的数额后，应当支付相应的差额。</span
          >
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span>&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt">
          <span style="font-weight: bold">投保人、被保险人义务</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十七条 </span><span>订立保险合同，保险人就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除合同。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿责任，但应当退还保险费。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十八条&nbsp;&nbsp;</span
          ><span style="font-weight: bold; color: #030303">约定一次性缴付保险费的，投保人未按照保险合同的约定缴付全部保费的，保险合同不生效，保险人对缴费前的保险事故不承担保险责任。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold; color: #030303"
            >约定以分期付款方式缴付保险费的，应在保险合同中载明分期缴付的周期，投保人应按约定缴付首期保险费，如投保人未按合同约定缴付首期保险费，保险合同不生效，保险人不承担保险责任。如投保人未按约定日期缴付第二期或以后任何一期保险费的，保险人有权解除本保险合同，本保险合同自解除通知送达投保人时解除；在本保险合同解除前发生保险事故的，保险人按照本保险合同约定赔偿保险金，但需扣减投保人欠缴的保险费。</span
          >
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第十九条&nbsp;&nbsp;被保险人应当严格遵守国家及交通运输部门关于安全运输的各项规定，还应当接受并协助保险人对承运货物进行查验和防损工作。</span
          ><span style="font-weight: bold">被保险人未履行其对保险标的安全应尽的责任的，保险人有权要求增加保险费或者解除本保险合同。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十条&nbsp;&nbsp;货物发生保险责任范围内的损失时，被保险人应立即通知保险人，</span
          ><span style="font-weight: bold">故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担赔偿或者给付保险金的责任，</span
          ><span>但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。</span
          ><span>同时，被保险人还应迅速采取得力有效的施救和保护措施，尽一切可能减少货物损失和防止货物损失的进一步扩大，</span
          ><span style="font-weight: bold">否则，对因此扩大的损失，保险人不承担赔偿责任</span><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt"><span>&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt">
          <span style="font-weight: bold">货物检验及赔偿处理</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十一条 </span><span> 承运货物出险后，被保险人应在24小时内向保险人报案，并申请会同检验受损的货物。</span>
          <span style="font-weight: bold">故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担赔偿或者给付保险金的责任，</span>
          <span>但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十二条&nbsp;&nbsp;被保险人向保险人申请索赔时，必须提供下列有关单证：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（一）保险凭证、运单（货票）提货单、发货票；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（二）出险地事故处理部门的出险证明、事故调解书；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（三）收货单位的入库记录、检验报告、损失清单及救护货物所支付的直接费用的单据；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（四）投保人、被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">被保险人未履行前款约定的索赔材料提供义务，导致保险人无法核实损失情况的，保险人对无法核实部分不承担赔偿责任。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>保险人在接到上述索赔单证后，根据保险责任范围，核定应否赔偿，经保险人与被保险人就赔偿金额达成协议后，应在十天内赔付。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十三条&nbsp;&nbsp;发生保险责任范围内的损失时，保险人按以下方式计算赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（一）承运人的赔偿责任低于每次事故赔偿限额的，按承运人的实际赔偿责任计算保险赔偿金额</span><span>；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（二）承运人的赔偿责任高于每次事故赔偿限额的，按照每次事故赔偿限额计算赔偿</span><span>；</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（三）在保险期间内，保险人对多次事故承担的赔偿金额之和累计不超过累计赔偿限额</span><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十四条&nbsp;&nbsp;</span
          ><span
            >发生保险责任范围内的损失，应由有关责任方负责赔偿的，保险人自向被保险人赔偿保险金之日起，在赔偿金额范围内代位行使被保险人对有关责任方请求赔偿的权利，被保险人应当向保险人提供必要的文件和所知道的有关情况。</span
          >
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>被保险人已经从有关责任方取得赔偿的，保险人赔偿保险金时，可以相应扣减被保险人已从有关责任方取得的赔偿金额。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">保险事故发生后，在保险人未赔偿保险金之前，被保险人放弃对有关责任方请求赔偿权利的，保险人不承担赔偿责任</span
          ><span>；保险人向被保险人赔偿保险金后，被保险人未经保险人同意放弃对有关责任方请求赔偿权利的，该行为无效；</span
          ><span style="font-weight: bold">由于被保险人故意或者因重大过失致使保险人不能行使代位请求赔偿的权利的，保险人可以扣减或者要求返还相应的保险金</span><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十五条 被保险人给托运人或</span><span>收货人</span><span>造成损害，被保险人对该托运人或</span><span>收货人</span
          ><span>应负的赔偿责任确定的，根据被保险人的请求，保险人应当直接向该托运人、</span><span>收货人</span><span>或其赔偿权利人赔偿；被保险人怠于请求的，托运人、</span><span>收货人</span
          ><span>或其赔偿权利人就其应获赔偿部分直接向保险人请求赔偿保险金。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十六条&nbsp;&nbsp;</span><span>保险标的发生损失的，遭受损失后的残余部分，经双方商定后进行处理，如折归被保险人的，由双方协商确定其价值，从赔款中扣除</span
          ><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">争议处理</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十七条 </span
          ><span>因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构且争议发生后未达成仲裁协议的，依法向中华人民共和国境内</span
          ><span style="font-weight: bold">（不包括港澳台地区）</span><span>有管辖权的人民法院起诉。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十八条 </span><span>本保险合同的争议处理适用中华人民共和国法律（不包括港澳台地区法律）</span><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">其他事项</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二十九条</span><span>&nbsp;&nbsp;保险责任开始后，投保人、保险人不得解除保险合同。但保险人依据本保险条款第</span
          ><span style="font-weight: bold">十七条条取得合同解除权的不受本条限制。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span>&#xa0;</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">释义</span></p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21.1pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">【</span
          ><span>每次事故赔偿限额】即在保险合同中约定的，保险人对于被保险人每一次事故所能赔付的最高金额。这一限额是保险赔偿的上限，一旦达到，保险人对此次事故的赔偿责任即告终止。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 7.8pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>【累计赔偿限额】是指在保险合同中明确规定的，保险公司在保险责任范围内对所有损失所能赔付的最高金额。这代表了保险公司对被保险人在整个保险期间内所有索赔的赔偿上限。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 14pt">
          <span style="font-weight: bold">中国平安财产保险股份有限公司</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 2.5pt; text-align: center; font-size: 14pt">
          <span style="font-weight: bold">平安附加国内公路货物运输盗抢险条款</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 2.5pt; text-align: center; font-size: 14pt">
          <span style="font-weight: bold">注册号：09AD2018000170175</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 2.5pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">总则</span></p>
        <p style="margin-top: 0pt; margin-bottom: 2.5pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第一条 本附加保险合同须附加于平安货物运输类保险合同（以下简称</span><span>“</span><span>主保险合同</span><span>”</span
          ><span>）。主保险合同所附条款、投保单、保险单、保险凭证以及批单等，凡与本附加保险合同相关者，均为本附加保险合同的构成部分。凡涉及本附加保险合同的约定，均应采用书面形式。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 2.5pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>若主保险合同与本附加保险合同的条款互有冲突，则以本附加保险合同的条款为准。本附加保险合同未尽事宜，以主保险合同的条款规定为准。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">保险责任</span></p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第二条 </span><span>本保险单扩展承保下列原因导致的被保险货物的损失或相关费用：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（一）在保险期间内，被保险货物在运输途中（指货物尚未卸离交通工具，运输车辆在路途上或中途停靠地）被盗窃、被抢劫、被抢夺，经县级以上公安刑侦部门立案证实，满一个月未查明下落。</span
          ><span style="font-weight: bold">盗窃须有明显的盗窃痕迹。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（二）在保险期间内装载被保险货物的交通工具发生交通事故，被保险货物遭受哄抢，经县级以上公安刑侦部门立案证实，满一个月未查明下落的。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（三）在保险期间内，被保险货物在运输途中被盗窃、被抢劫、被抢夺期间受到损坏或为抢救、保护货物所支付的直接、合理的费用。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">责任免除</span></p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第三条&nbsp;&nbsp;因下列原因引起的货物损失或下列各项损失，保险人不负责赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（一）货物不明原因的失踪、下落不明、丢失、提货不着。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（二）提货（收货）清点时件数的短缺，重量的短少。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（三）被他人诈骗造成的全车货物或部分损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（三）被保险货物被盗窃、被抢劫、被抢夺期间，被保险货物导致第三者人员伤亡或财产损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（四）被保险人因违反政府有关法律、法规被有关国家机关罚没、扣押。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（五）被保险人因与他人的民事、经济纠纷而致被保险货物被抢劫、被抢夺。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（六）运输车辆、被保险货物、本车驾驶员三者同时失踪。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（七）被保险人的故意行为或违法行为造成的损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（八）其它不属于保险责任范围内的损失。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">保险金额</span></p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第四条 </span><span>本附加险保险金额按货价或货价加运杂费计算。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">被保险人义务</span></p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第五条</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（一）被保险人得知或应当得知被保险货物被盗窃、被抢劫或被抢夺后，应在24小时内（不可抗力因素除外）向当地公安部门报案，同时在48小时内通知保险人。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">（二）被保险人向保险人索赔时，除了提供主条款须提供的证明文件外，还须提供出险地县级以上公安刑侦部门出具的盗抢案件证明。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">赔偿处理</span></p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第六条</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（一）根据被保险人提供的索赔单证，保险人按以下规定赔偿：</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>1、按主条款有关赔偿处理的规定计算赔偿金额，确定损失金额后，按损失金额的20%扣除绝对免赔金额。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>2、赔偿的总金额不超过保险金额。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>3、被保险人索赔时未能向保险人提供出险地县级以上公安刑侦部门出具的盗抢案件证明，保险人不负赔偿责任</span><span>。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span>（二）保险人确认索赔单证齐全、有效后，由被保险人签具权益转让书，赔付结案。</span>
        </p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-align: center; font-size: 10.5pt"><span style="font-weight: bold">其它事项</span></p>
        <p style="margin-top: 0pt; margin-bottom: 6pt; text-indent: 21pt; text-align: justify; font-size: 10.5pt">
          <span style="font-weight: bold">第七条&nbsp;&nbsp;保险人赔偿后，如被盗抢的被保险货物找回，应将货物归还被保险人，同时收回相应的赔款。</span>
        </p>
      </div>
      <div class="close-btn" @click="closeClause">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InsClause",
  methods: {
    closeClause() {
      this.$router.back(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.clause-wrapper {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  .clause-body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    color: #333;
    background-color: #fff;
    z-index: 9999;
    -webkit-transition: 300ms all;
    transition: 300ms all;
    .header {
      height: 13.33vw;
      line-height: 13.33vw;
      font-size: 4.8vw;
      font-weight: bold;
      border-bottom: 0.27vw solid #f5f5f9;
      text-align: center;
    }
    .content {
      height: 60vh;
      padding: 2.67vw 5vw;
      overflow: auto;
      text-align: justify;
    }
    .close-btn {
      height: 12vw;
      line-height: 12vw;
      text-align: center;
      color: #ffffff;
      background: #3385ff;
    }
  }
}
</style>
